/* eslint-disable no-unused-vars */
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Table from '../../components/Table/Table';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import { useEffect, useState } from 'react';
import queryString from 'query-string';
import moment from 'moment';
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import { currentUser } from '../../utils/Auth/auth';
import { Tooltip } from 'react-tooltip';
import Select from 'react-select';
import { branchNamesCaliforniaIncluded } from '../../constants/enums/RefundContacts';
import ReactPaginate from 'react-paginate';
import EditingUserFrame from '../../components/AddingUser/EditingUserFrame';
import AddingUserFrame from '../../components/AddingUser/AddingUserFrame';

const getCustomerCdColor = (user) => {
  switch (user) {
    case 'OOREG' || 'OODOV':
      return 'text-gray-400';
    case 'GUEST':
      return 'text-orange-500';
    default:
      return 'text-green-600';
  }
};

const Users = ({ swalModal }) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = queryString.parse(search);

  const [pageLoading, setPageLoading] = useState(false);
  const [loadingUserRow, setLoadingUserRow] = useState();

  const [userList, setUserList] = useState([]);
  const [branchId, setBranchId] = useState();
  const [email, setEmail] = useState(params.email);
  const [firstName, setFirstName] = useState(params.firstName);
  const [lastName, setLastName] = useState(params.lastName);
  const [phone, setPhone] = useState(params.phone);

  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();

  const [agentsForSearch, setAgentsForSearch] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState([]);

  const branchOptions = [
    {
      value: '1',
      label: '1 - Canada',
      isDisabled:
        !currentUser.branches.includes('1') &&
        !currentUser.baseBranch.includes('1'),
    },
    {
      value: '2',
      label: '2 - New Jersey',
      isDisabled:
        !currentUser.branches.includes('2') &&
        !currentUser.baseBranch.includes('2'),
    },
    {
      value: '3',
      label: '3 - California',
      isDisabled:
        !currentUser.branches.includes('3') &&
        !currentUser.baseBranch.includes('3'),
    },
    {
      value: '4',
      label: '4 - Chicago',
      isDisabled:
        !currentUser.branches.includes('4') &&
        !currentUser.baseBranch.includes('4'),
    },
  ];

  const openUserEditModal = async (id) => {
    setLoadingUserRow(id);
    const result = await request({
      url: `${controllers.user}getUser`,
      type: requestTypes.post,
      params: { id },
    });
    if (result?.code === responseTypes.success) {
      const user = result.result;
      swalModal.fire({
        title: `Edit the user ${user?.email}`,
        html: <EditingUserFrame data={user} swalModal={swalModal} />,
        showCancelButton: false,
        showConfirmButton: false,
        cancelButtonText: 'Close',
        customClass: {
          confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
          cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
          popup: 'w-[95vw] min-h-[70vh] text-sm',
        },
      });
    }
    setLoadingUserRow(null);
  };

  const userStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'text-green-500';
      case 'inactive':
        return 'text-red-500';
      default:
        return 'text-orange-400';
    }
  };

  const displayUsers = (data) => {
    return data?.map((item) => ({
      Agent: (
        <div className={classNames(getCustomerCdColor(item.customerCd))}>
          {item.customerCd}
        </div>
      ),
      Branch: branchNamesCaliforniaIncluded[item?.branchId],
      Email: item.email || '---',
      Role: item.role || '---',
      FullName: `${item.firstName || '---'} ${item.lastName || '---'}`,
      Phone: item.phone || '---',
      RegDate: !item.registrationDate
        ? '---'
        : moment(item.registrationDate).format('MMM DD, YYYY'),
      Status: (
        <div
          className={classNames(
            '!capitalize font-semibold',
            userStatusColor(item.status),
          )}
        >
          {item.status?.toLowerCase() || '---'}
          {item.status?.toLowerCase() !== 'active' &&
            item.status?.toLowerCase() !== 'inactive' &&
            ' !'}
        </div>
      ),
      ViewEdit: (
        <div className="text-center min-w-10">
          <span
            onClick={() => openUserEditModal(item.id)}
            className={classNames(
              'rounded-xl bg-blue-800 text-white px-2 cursor-pointer hover:bg-blue-900 hover:transition-all hover:duration-300',
              loadingUserRow === item.id ? 'hidden' : null,
            )}
          >
            DETAILS
          </span>
          <img
            src={loadingGif}
            className={classNames(
              'sm:w-3 sm:h-3 md:w-4 md:h-4 w-2 h-2 mx-auto',
              loadingUserRow !== item.id ? 'hidden' : null,
            )}
          />
        </div>
      ),
    }));
  };

  const headers = [
    'Agent/Customer code',
    'Branch',
    'Email',
    'Role',
    'Full name',
    'Phone',
    'Reg-tion date',
    'Status',
    <div className="text-center" key="vie-edit-btn">
      View/edit
    </div>,
  ];

  const changeBranch = async (selectedBranch, onPageLoad = false) => {
    if (selectedBranch) {
      setBranchId(selectedBranch);
      const result = await request({
        url: `${controllers.agent}getAgentsByBranch`,
        type: requestTypes.post,
        params: { branchId: selectedBranch.value },
      });
      const agents = result?.map((a) => ({ value: a, label: a }));
      setAgentsForSearch(agents);
    } else {
      setAgentsForSearch([]);
    }
    if (!onPageLoad) setSelectedAgent(null);
    setBranchId(selectedBranch);
  };

  const getUsersList = async (page = 1) => {
    const result = await request({
      url: `${controllers.user}getUsersList`,
      type: requestTypes.post,
      params: { page },
      body: {
        branchId: params.branch,
        customerCd: params.customerCd,
        email: params.email,
        firstName: params.firstName,
        lastName: params.lastName,
        phone: params.phone,
      },
      setLoading: setPageLoading,
    });
    if (result?.code === responseTypes.success) {
      setUserList(result.result.users);
      setTotalPages(result.result.totalPages);
      setTotalItems(result.result.totalItems);
    }
  };

  useEffect(() => {
    changeBranch(
      branchOptions.find((option) => option.value === params.branch),
      true,
    );
    setSelectedAgent(
      params.customerCd
        ? { value: params.customerCd, label: params.customerCd }
        : null,
    );
  }, []);

  useEffect(() => {
    getUsersList(params.page);
  }, [search]);

  const getQueryParamsByPage = (pageNum) => {
    return {
      ...(branchId && { branch: branchId?.value }),
      ...(selectedAgent && { customerCd: selectedAgent?.value }),
      ...(firstName && { firstName }),
      ...(lastName && { lastName }),
      ...(email && { email }),
      ...(phone && { phone }),
      ...{ page: pageNum },
    };
  };

  const addNewUser = () => {
    swalModal.fire({
      title: `Add new user`,
      html: <AddingUserFrame data={{}} swalModal={swalModal} />,
      showCancelButton: false,
      showConfirmButton: false,
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-[95vw] min-h-[70vh] text-sm',
      },
    });
  };

  return (
    <div className="mb-16">
      <div className="w-full text-left px-10">
        <div className="my-2 my-5 text-blue-900 text-lg">Search by</div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Branch:</div>
          <Select
            value={branchId}
            onChange={(selected) => changeBranch(selected)}
            options={branchOptions}
            className="min-w-0 flex-grow text-left text-blue-800"
            placeholder="Choose branch..."
            isClearable={true}
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Agent:</div>
          <div
            data-tooltip-id="my-tooltip"
            data-tooltip-content={
              !branchId ? 'Need to select branch first' : null
            }
          >
            <Select
              isDisabled={!branchId}
              value={selectedAgent}
              onChange={(selected) => setSelectedAgent(selected)}
              options={agentsForSearch}
              className="min-w-0 flex-grow text-left text-blue-800"
              placeholder="Choose agent..."
              isClearable={true}
            />
          </div>
          <Tooltip id="my-tooltip" />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">{'Email (partial match):'}</div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="Email..."
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">First name:</div>
          <input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="First name..."
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Last name:</div>
          <input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="Last name..."
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Phone:</div>
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="Phone..."
          />
        </div>
      </div>
      <Link
        to={`/users?${queryString.stringify(getQueryParamsByPage(1))}`}
        className={classNames(
          'text-white text-lg bg-blue-900 w-auto inline-block py-1 px-5 rounded-full hover:bg-blue-800 hover:transition-all hover:duration-30 cursor-pointer my-10 mb-20',
          pageLoading && '!bg-gray-400 cursor-auto',
        )}
      >
        {'Search'}
      </Link>
      <div className="text-left m-5 text-blue-800">Total: {totalItems}</div>

      <div className="mb-10 mx-3">
        <ReactPaginate
          onPageChange={(e) => {
            const redirectPage = Number.parseInt(e.selected) + 1;
            navigate(
              `/users?${queryString.stringify(getQueryParamsByPage(redirectPage))}`,
            );
          }}
          forcePage={Number.parseInt(params.page) - 1 || 0}
          pageCount={totalPages}
          pageRangeDisplayed={4}
          marginPagesDisplayed={2}
          containerClassName={classNames(
            'flex flex-row w-1/2 float-left my-0 text-sm xl:text-sm',
          )}
          activeLinkClassName="!text-blue-400 !border-blue-400"
          pageLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
          previousLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
          nextLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
        />
      </div>
      <br />
      <div className="text-left text-blue-900 p-4 bg-none">
        Add new user
        <div
          onClick={addNewUser}
          className="cursor-pointer bg-blue-900 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-800 hover:transition-all hover:duration-300"
        >
          +
        </div>
      </div>
      <div>
        {pageLoading ? (
          <div className="text-center">
            <img src={loadingGif} className={classNames('w-8 h-8 mx-auto')} />
          </div>
        ) : (
          <Table
            data={displayUsers(userList)}
            headers={headers}
            rowsClassName="text-[0.68vw] font-semibold xl:font-normal xl:text-[0.6rem] 2xl:text-xs"
            headersClassNames="text-[0.68vw] md:font-semibold font-bold xl:text-[0.6rem] 2xl:text-xs"
          />
        )}
      </div>
    </div>
  );
};

export default Users;
